import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, plan, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-lg shadow-xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} className="text-destructive" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Delete Plan
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              Are you sure you want to delete the <span className="font-semibold text-foreground">{plan?.name}</span> plan? This action cannot be undone.
            </p>
            <div className="bg-warning/10 border border-warning/30 rounded-md p-3 mb-4">
              <p className="text-xs text-warning-foreground">
                <Icon name="Info" size={14} className="inline mr-1" />
                All users subscribed to this plan will need to be migrated to another plan.
              </p>
            </div>
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={onClose}
                fullWidth
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                onClick={onConfirm}
                iconName="Trash2"
                iconPosition="left"
                fullWidth
              >
                Delete Plan
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;